import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { env } from "@/env";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getR2VideoUrl(relativePath: string): string {
  const base = env.NEXT_PUBLIC_R2_PUBLIC_URL_BASE.replace(/\/+$/, "");
  const path = relativePath.startsWith("/")
    ? relativePath.slice(1)
    : relativePath;
  return `${base}/${path}`;
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}

export function getDayName(dayNumber: number): string {
  const days = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  return days[dayNumber - 1] || `Día ${dayNumber}`;
}

export function stripHtmlAndTruncate(
  html: string | null | undefined,
  maxLength: number = 100,
): string {
  if (!html) return "N/A";
  const plainText = html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (plainText.length <= maxLength) return plainText;
  return plainText.slice(0, maxLength).trim() + "...";
}

export function translateDifficultyLevel(level: string): string {
  const translations: Record<string, string> = {
    beginner: "Principiante",
    intermediate: "Intermedio",
    advanced: "Avanzado",
  };
  return translations[level.toLowerCase()] || level;
}
